import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { _AbcButtonComponent, _AbcContextMenuComponent } from '@barthauer/abc/ui-components';
import { FlexLayoutModule } from 'ngx-flexible-layout';

import { CommonModule } from '@angular/common';

import { BehaviorSubject, Subscription } from 'rxjs';
import { finalize, map } from 'rxjs/operators';

import { NotificationSettingsComponent } from '../../../shared/notification/notification-settings/notification-settings.component';
import { DataService as aimsDataservice } from '../../../services/data.service';
import { ConfirmationPopupComponent } from '../../../shared/confirmation-popup/confirmation-popup.component';
import { notificationPrefixMap } from '../notification-list/notification-list.component';
import { INotificationItem, NotificationCategory, NotificationService1 } from '../../../services/notification1.service';
import { DatePipe } from '../../../shared/pipes/date.pipe';
import { Router } from '@angular/router';
@Component({
  selector: 'notification-details',
  templateUrl: './notification-details.component.html',
  styleUrls: ['./notification-details.component.scss'],
  providers: [],
  imports: [
    CommonModule,
    FlexLayoutModule,
    _AbcContextMenuComponent,
    _AbcButtonComponent,
    NotificationSettingsComponent,
    ConfirmationPopupComponent,
    DatePipe

  ],
})
export class NotificationDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('contextMenuActions') contextMenuActions: _AbcContextMenuComponent;
  @ViewChild('markNotificationAsReadPopup') markNotificationAsReadPopup: ConfirmationPopupComponent;
  @ViewChild('notificationSettings') notificationSettings: NotificationSettingsComponent;

  private notificationItem$ = new BehaviorSubject<INotificationItem>(undefined);
  @Input()
  set notificationItem(value: INotificationItem) {
    this.notificationItem$.next(value);
  }

  get notificationItem(): INotificationItem {
    return this.notificationItem$.getValue();
  }

  @Output() hidePopupEvent = new EventEmitter<boolean>();
  @Output() updateNotification: EventEmitter<any[]> = new EventEmitter<any[]>();
  protected showLoader: boolean = false;
  protected isContextMenuVisible: boolean = false;
  protected contextMenuItems = [];
  protected identifier$ = this.notificationItem$.pipe(
    map((notification) => {

      return (

        this.generateNotificationIdentifier(notification.Category, notification.SysDateTimeInsert.toString())
      );
    })
  );

  private subscriptions: Subscription[] = [];

  constructor(
    private notificationService: NotificationService1,
    private router: Router,
    public readonly aimsDataservice: aimsDataservice
  ) { }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  protected onOpenActionButtonsMenu(event: any): void {
    this.isContextMenuVisible = true;
    const targetElement = event.event.target;
    this.contextMenuItems = [];
    if (this.notificationItem.Reminder.LastVisitedDate === null) {
      this.contextMenuItems.unshift({
        text: this.aimsDataservice.res('notification-markAsRead'),
        onClick: async () => {
          if (await this.markNotificationAsReadPopup.open()) {
            this.showLoader = true;
            this.subscriptions.push(
              this.notificationService
                .markNotificationAsRead(this.notificationItem.Id)
                .pipe(
                  finalize(() => {
                    this.showLoader = false;
                  })
                )
                .subscribe()
            );
          }
        },
      });
    }

    this.contextMenuActions.position = {
      my: 'right top',
      at: 'right bottom',
      of: targetElement,
      offset: '0 8',
    };
    this.contextMenuActions.instance.show();
  }

  protected onContextMenuHidden(): void {
    this.isContextMenuVisible = false;
    this.contextMenuActions.instance.hide();
  }

  protected onHidePopUp(): void {
    this.hidePopupEvent.emit(false);
  }

  protected handleUpdateNotification(notification: any[]) {
    this.updateNotification.emit(notification);
  }

  protected navigateToDetails(): void {
    this.router.navigate(['measureDetail', 'measures', this.notificationItem.MeasureId]);
  }

  private generateNotificationIdentifier(source: NotificationCategory, date: string): string {
    const prefix = notificationPrefixMap[source];
    if (prefix === undefined) {
      throw new Error(`No prefix defined for NotificationCategory: ${source}`);
    }
    return `${this.aimsDataservice.getIdentifier(prefix, date)}`;
  }
}
